import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PayOut from "./payOut";
import PaidOut from "./paidOut";

const shipperTabs = [
  { name: "Pay Out Requests", href: "payouts" },
  { name: "Paid Out Requests", href: "paid" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SingleShipperRevenue() {
  const DEFAULT_ACTIVE_TAB = "payouts";
  const navigate = useNavigate();
  const { id, active_tab } = useParams();

  useEffect(() => {
    if (!active_tab) {
      navigate(`/admin/revenue/shipper/${id}/${DEFAULT_ACTIVE_TAB}`);
    }
    // eslint-disable-next-line
  }, []);

  const toggle = (tab) => {
    if (active_tab !== tab.href) {
      navigate(`/admin/revenue/shipper/${id}/${tab.href}`);
    }
  };

  return (
    <div data-test="shipper-revenue-page">
      {/* Horizontal Shipper Tabs */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav
          className="-mb-px flex space-x-8 overflow-x-auto"
          aria-label="Shipper Tabs"
        >
          {shipperTabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => toggle(tab)}
              className={classNames(
                tab.href === active_tab
                  ? "border-primary text-primary font-bold"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300",
                "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
              )}
              aria-current={tab.href === active_tab ? "page" : undefined}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {active_tab === "payouts" && <PayOut />}
        {active_tab === "paid" && <PaidOut />}
      </div>
    </div>
  );
}
